export default {
      id: "dragnDrop-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#dragnDrop-usage",
      toString: function () {
        return this.url;
      }
    }